export const specInputMakanSiang = [
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Apakah Makan Siang?',
    name: 'is_lunch_at_office',
    type: 'text',
  },
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Apakah Puasa?',
    name: 'is_fasting',
    type: 'text',
  },
];

export const specInputAlasanTerlambat = [
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Alasan Terlambat',
    name: 'reason_late',
    type: 'text',
  },
];
